// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "bootstrap";
import BootstrapVue from "bootstrap-vue";
import Treeselect from "@riophae/vue-treeselect";

import "flatpickr/dist/themes/material_blue.css";
import "material-design-icons/iconfont/material-icons.css";
import "typeface-roboto/index.css";

import "animate.css/animate.min.css";

import "snackbarjs";

import App from "./App";
import router from "./router";
import globals from "./globals";
import feature from "./feature";
import store from "./store";
import 'material-symbols/outlined.css';

// Import JS services
import appService from "./services/app.service";
Object.defineProperty(Vue.prototype, "$appService", {
  value: appService,
});

// Import Keycloak JS Adapter
import * as Keycloak from "keycloak-js";
import VueLogger from "vuejs-logger";
const options = {
  isEnabled: true,
  logLevel: Vue.config.productionTip ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};
Vue.use(VueLogger, options);
import VueCurrencyInput from "vue-currency-input";
Vue.use(VueCurrencyInput);

Vue.use(BootstrapVue);
Vue.component("treeselect", Treeselect);

Vue.config.productionTip = false;

Vue.prototype.globals = globals;
Vue.prototype.feature = feature;

let initOptions = {
  url: process.env.AUTH_URL,
  realm: process.env.AUTH_REALM,
  clientId: process.env.AUTH_CLIENT_ID,
  onLoad: "login-required",
  enableLogging: false,
};

if (process.features.target.includes("dev-audi")) {
  if (initOptions.url == undefined) {
    initOptions.url =
      "https://dev.authentication.audi-mysteryshopping.com/auth";
  }
  if (initOptions.realm == undefined) {
    initOptions.realm = "AudiLoopDev";
  }
  if (initOptions.clientId == undefined) {
    initOptions.clientId = "loopOpFrontend";
  }
  if (initOptions.onLoad == undefined) {
    initOptions.onLoad = "login-required";
  }
}

if (appService.getAccessToken())
  initOptions = {
    ...initOptions,
    token: appService.getAccessToken(),
    refreshToken: appService.getRefreshToken(),
    idToken: appService.getIdToken(),
  };

let keycloak = Keycloak(initOptions);
try {
  keycloak
    .init(initOptions)
    .success((auth) => {
      if (!auth) {
        appService.removeTokensFromStorage();
        window.location.reload();
      } else {
        appService.storeTokensInStorage(
          keycloak.token,
          keycloak.idToken,
          keycloak.refreshToken
        );
        appService.configureAjaxSetup();

        new Vue({
          el: "#app",
          router,
          store,
          template: "<App/>",
          components: {
            App,
          },
          render: (h) => h(App),
        }).$mount("#app");
      }

      //Token Refresh
      setInterval(() => {
        keycloak
          .updateToken(70)
          .success((refreshed) => {
            if (refreshed) {
              appService.storeTokensInStorage(
                keycloak.token,
                keycloak.idToken,
                keycloak.refreshToken
              );
              appService.configureAjaxSetup();
            } else {
              console.warn(
                "Token not refreshed, valid for " +
                  Math.round(
                    keycloak.tokenParsed.exp +
                      keycloak.timeSkew -
                      new Date().getTime() / 1000
                  ) +
                  " seconds"
              );
            }
          })
          .error(() => {
            console.error("Failed to refresh token!");
            appService.removeTokensFromStorage();
            window.location.reload();
          });
      }, 20000);
    })
    .error(() => {
      console.error("Authentification failed!");
      appService.removeTokensFromStorage();
      window.location.reload();
    });
} catch (error) {
  console.warn("Something went wrong. Redirecting to login.");
  appService.removeTokensFromStorage();
  window.location.reload();
}

export { keycloak };



// WEBPACK FOOTER //
// ./src/main.js